import status from "../constants/actionStatus";

export default (
    state = {
        recentCourse: {},
    },
    action = {}
) => {
    switch (action.type) {
    case "ADD_TO_RECENT_COURSE_REQUEST":
        return {
            status: status.PENDING,
            recentCourse: {},
        };
    case "ADD_TO_RECENT_COURSE_SUCCESS":
        return {
            status: status.SUCCESS,
            recentCourse: action.payload,
        };

    case "ADD_TO_RECENT_COURSE_FAILURE":
        return {
            status: status.ERROR,
            recentCourse: {},
        };
    default:
        return state;
    }
};
